import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js"; // 处理猫眼微信站适配

import Drip from 'drip'; // ci json 文件

import f2eJson from '../../f2eci.json'; // 生产环境

export var isProd = process.env.DEPLOY_ENV === 'production' || /product|ppe/.test(f2eJson.env); // 不同环境下的域名配置

export var wxMyDomainUrl = isProd ? 'm.maoyan.com/myshow/fe' : 'myshow.test.maoyan.com/fe'; // 电影北京域名

export var wxMyBjDomainUrl = isProd ? 'm.maoyan.com/dianpingmmweb' : 'canary5.fe.st.maoyan.com/dianpingmmweb'; // wxApi

export var wxApiUrl = "//s0.meituan.net/bs/delivr/0315c86:jsm/lib/weixin/jweixin-1.1.0.js"; // 猫眼微信环境标识

export var myOriginAndWx = /maoyan.com/.test(location.host) && window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) === 'micromessenger'; // 电影相关请求链接

export var wxConfigUrl = 'https://m.maoyan.com/wechat?channelId=70001'; // 站点协议

export var protocol = /^file/.test(location.protocol) ? "http://" : "//"; // 域名

export var domain = isProd ? "h5.dianping.com" : "h5.51ping.com"; // 页面访问路径前缀

export var preUrl = "".concat(protocol).concat(domain); // 应用名

export var webName = "maoyan-show-h5"; // 日期格式

export var dateFmtStr = 'yyyy-MM-dd'; // ajax请求前缀

export var ajaxPreUrl = isProd ? Drip.constant.ajaxUrl : Drip.constant.ajaxBetaUrl; // fans请求前缀

export var fansAjaxPreUrl = isProd ? 'https://fans.maoyan.com/myshow/ajax' : '//fans.test.maoyan.com/myshow/ajax'; // live请求前缀

export var livePreUrl = isProd ? 'https://yanchu.maoyan.com/api/mobile' : '//show.test.maoyan.com/api/mobile'; // 周边商品的url

export var mallUrl = isProd ? 'https://store.maoyan.com' : 'http://canary.movie.test.maoyan.com'; // 工具项目的url

export var toolUrl = isProd ? 'https://show.maoyan.com/app/myshow-alien/' : 'https://show.test.maoyan.com/app/myshow-alien/'; // 会员中心url

export var vipCenterUrl = isProd ? 'https://m.maoyan.com/apollo/vip' : 'https://i.test.maoyan.com/apollo/vip';